module.exports = __webpack_public_path__ + "assets/img/TagCloud.708173c9.png";